export enum ROLES {
  admin = 'admin',
  user = 'user',
}

export enum PENDING_SIGNUP_STATUS {
  pending = 'pending',
  registered = 'registered',
  notFound = 'not-found', // Used when backend send error 404
}
